import { render } from "./CatalogProductSwitch.vue?vue&type=template&id=3cf3b71e&ts=true"
import script from "./CatalogProductSwitch.vue?vue&type=script&lang=ts"
export * from "./CatalogProductSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__